<ng-container *ngIf="activeBar">
  <ng-container *ngFor="let barPart of activeBar.chartBarParts">
    <div class="total-padding flex flex-col justify-between items-center" *ngIf="!barPart.color">
      <span
        class="min-width total-text-value"
        *ngIf="
          energyService.getTransformedEnergyDetailsFromValueAndUnit(totalBarValue, barPart.unit)
            | featureLike: 'value':'unit' as featureLike
        "
      >
        {{ featureLike | value2: featurePropertyKey.value:'':'1.0-2' }}
        {{ featureLike | unit: featurePropertyKey.value }}
      </span>
      <p class="text-description">
        {{ barPart.designationKey | translate }}, {{ activeBar.designationKey | translate }}
      </p>
    </div>
  </ng-container>
  <div class="flex flex-row justify-around items-start">
    <ng-container *ngFor="let barPart of activeBar.chartBarParts">
      <div
        class="consumption-padding flex flex-col justify-between items-center"
        *ngIf="barPart.color"
      >
        <span
          class="min-width consumption-text-value"
          [ngClass]="barPart.color"
          *ngIf="
            energyService.getTransformedEnergyDetailsFromValueAndUnit(barPart.value, barPart.unit)
              | featureLike: 'value':'unit' as featureLike
          "
        >
          {{ featureLike | value2: featurePropertyKey.value:'':'1.0-2' }}
          {{ featureLike | unit: featurePropertyKey.value }}
        </span>
        <p class="text-description">
          {{ barPart.designationKey | translate }}, {{ activeBar.designationKey | translate }}
        </p>
      </div>
    </ng-container>
  </div>
</ng-container>
